import { create, filter, findAll, findOne, getOne, resetSave, update } from "@/store/Crud/functions/actions";
export default {
    create,
    filter,
    findOne,
    update,
    findAll,
    getOne,
    resetSave,
};
